module.exports = "/_next/static/images/OgRequestIntegration-0d404c8e1b505bc9845091735f1d48e2.jpg";